import {select, take, fork, put} from 'redux-saga/effects';
import {arcGISTravelModeTypes} from '@ace-de/eua-arcgis-rest-client';
import fetchRequest from '../../application/sagas/fetchRequest';
import * as sapActionTypes from '../sapActionTypes';
import config from '../../config';

const loadSAPMapPickupToTowingStaticRoute = function* loadSAPMapPickupToTowingStaticRoute({payload}) {
    const {serviceManager} = yield select(state => state.application);

    const {match} = payload;
    const {serviceCaseId, serviceAssignmentLineNo} = match.params;
    const {serviceAssignments} = yield select(state => state.serviceAssignments);
    const serviceAssignmentId = `${serviceCaseId}-${serviceAssignmentLineNo}`;
    const serviceAssignment = serviceAssignments[serviceAssignmentId];
    const {pickupLocation, destination} = serviceAssignment;

    if (!serviceAssignment || !pickupLocation || !destination) return;

    if (config.IS_FALLBACK_SYSTEM) {
        const googleMapsService = serviceManager.loadService('googleMapsService');

        yield fork(
            fetchRequest,
            sapActionTypes.FETCH_PICKUP_LOCATION_TO_TOWING_DESTINATION_ROUTE_REQUEST,
            googleMapsService.getRoute,
            {
                origin: {
                    location: {
                        latLng: {
                            latitude: pickupLocation?.latitude,
                            longitude: pickupLocation?.longitude,
                        },
                    },
                },
                destination: {
                    location: {
                        latLng: {
                            latitude: destination?.latitude,
                            longitude: destination?.longitude,
                        },
                    },
                },
                fields: ['routes.distanceMeters', 'routes.duration', 'routes.polyline.encodedPolyline'],
            },
        );

        const routeResponseAction = yield take([
            sapActionTypes.FETCH_PICKUP_LOCATION_TO_TOWING_DESTINATION_ROUTE_REQUEST_FAILED,
            sapActionTypes.FETCH_PICKUP_LOCATION_TO_TOWING_DESTINATION_ROUTE_REQUEST_SUCCEEDED,
        ]);

        if (!routeResponseAction.error) {
            const {response} = routeResponseAction.payload;
            const {routes} = response;
            const pickupToTowingDestinationRoute = routes[0];

            yield put({
                type: sapActionTypes.STORE_PICKUP_TO_TOWING_DESTINATION_STATIC_ROUTE,
                payload: {
                    googleRouteDTO: {
                        totalKilometers: pickupToTowingDestinationRoute?.distanceMeters
                            ? pickupToTowingDestinationRoute.distanceMeters / 1000
                            : 0,
                        totalTravelTime: pickupToTowingDestinationRoute?.duration
                            ? Number(pickupToTowingDestinationRoute?.duration.replace('s', '')) / 60
                            : 0,
                        encodedPolyline: pickupToTowingDestinationRoute?.polyline?.encodedPolyline,
                    },
                },
            });
        }

        return;
    }

    const arcGISRESTService = serviceManager.loadService('arcGISRESTService');

    yield fork(
        fetchRequest,
        sapActionTypes.FETCH_PICKUP_LOCATION_TO_TOWING_DESTINATION_ROUTE_REQUEST,
        arcGISRESTService.getRoute,
        {
            startingPoint: {
                longitude: pickupLocation.longitude,
                latitude: pickupLocation.latitude,
            },
            destination: {
                longitude: destination.longitude,
                latitude: destination.latitude,
            },
            travelModeType: arcGISTravelModeTypes.TRUCK_TRAVEL_TIME,
            startTime: 'now',
        },
    );

    const routeResponseAction = yield take([
        sapActionTypes.FETCH_PICKUP_LOCATION_TO_TOWING_DESTINATION_ROUTE_REQUEST_FAILED,
        sapActionTypes.FETCH_PICKUP_LOCATION_TO_TOWING_DESTINATION_ROUTE_REQUEST_SUCCEEDED,
    ]);

    if (!routeResponseAction.error) {
        const {response} = routeResponseAction.payload;
        const {arcGISRouteDTO} = response;

        yield put({
            type: sapActionTypes.STORE_PICKUP_TO_TOWING_DESTINATION_STATIC_ROUTE,
            payload: {arcGISRouteDTO},
        });
    }
};

export default loadSAPMapPickupToTowingStaticRoute;
